import { useTheme } from '../lib/theme';

export default function ThemeToggle() {
  const { effective, toggle } = useTheme();
  return (
    <button onClick={toggle}
      aria-label="Toggle theme"
      className="w-10 h-10 rounded-full border border-arena-200 dark:border-neon-400/30
                 grid place-items-center bg-white/70 dark:bg-arena-800/70
                 text-arena-700 dark:text-neon-300
                 active:scale-95 transition">
      {effective === 'dark' ? (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>
      ) : (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
          <path d="M12 4V2M12 22v-2M4 12H2M22 12h-2M4.93 4.93L3.5 3.5M20.5 20.5l-1.43-1.43M4.93 19.07L3.5 20.5M20.5 3.5l-1.43 1.43" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <circle cx="12" cy="12" r="4.5"/>
        </svg>
      )}
    </button>
  );
}
